module.exports = __webpack_public_path__ + "img/1296191648.615912d7.jpg";